import React, { Fragment } from "react";
import moment from "moment";
import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import { CONFIGURATION } from "utilities/configuration";
import { CONSTANTS } from "utilities/constants";
import ProductTypeIcon from "../common/productTypeIcon/productTypeIcon";
import "./productType.scss";
import { Icon } from "__ICON_REFERENCE__";

const FlightSection = ({ flights, sectionHeading, ...props }) => {
    if(!flights || flights.length === 0) return null;
    return <div className="flights-section">
        <div className="sub-heading margin-bottom">{sectionHeading}</div>
        <div className="flights-grid">
            {flights.map((flight, index) => (
                <div key={"flight-index"}>
                    <div className="flight-route">
                        <Icon name="flight" className="margin-right" /> {flight?.departure?.name && <span>{flight?.departure?.name}</span>}
                        {flight?.departure?.code && <span className="flight-code">({flight?.departure?.code})</span>}
                        {flight?.departure?.name && flight?.arrival?.name && <span className="flight-code">-</span>}
                        {flight?.arrival?.name && <span>{flight?.arrival?.name}</span>}
                        {flight?.arrival?.code && <span className="flight-code">({flight?.arrival?.code})</span>}
                    </div>
                    <div className="flight-date">
                        {flight?.departure.date && <span>{moment(flight.departure.date).format(CONFIGURATION.DATE_FORMAT_WITH_WEEK)}</span>}
                        {flight?.duration && <><span className="dot-splitter"></span><span>{commonUtilities.formatDuration(flight?.duration)}</span></>}
                    </div>
                    {flight?.flightNo&&<div className="flight-no">{flight?.airlineName} {flight?.flightNo}</div>}
                    <div className="flight-time">
                        {flight?.departure?.time && <><span className="time-label departure">{props.localize("qma-depart")}:</span><span className="time-value">{flight?.departure?.time}</span></>}
                        {flight?.arrival?.time && <><span className="time-label arrival">{props.localize("qma-arrive")}:</span><span className="time-value">{flight?.arrival?.time}</span></>}
                    </div>
                </div>
            ))}
        </div>
        
        
    </div>;
};

const ProductType = (props) => {

    const { productType } = props;

    const andLabel = props.localize("qma-and");
    const childrenLabel = props.localize(productType?.noOfChildren > 1 ? "qma-children" : "qma-child");
    const adultLabel = props.localize(productType?.noOfAdults > 1 ? "qma-adults" : "qma-adult");

    const outboundFlights = (productType?.flights?.data?.outboundFlights || []).filter(s => s.selected);
    const inboundFlights = (productType?.flights?.data?.inboundFlights || []).filter(s => s.selected);

    const productTypeCode = productType?.productType?.code?.toLowerCase();

    return (
        <Fragment>
            {productType ? (
                <div className="row" data-testid="prod-comp">
                    <div className="row" >

                        {
                            productType?.departure?.code && `${props.localize("qma-from")} (${productType?.departure?.code}) ${productType?.departure?.name} `
                        }
                        {
                            productType?.destination?.providerCode && `${props.localize("qma-to")} (${productType.destination?.providerCode}) ${productType?.destination?.name}`
                        }

                    </div>

                    <div className="row">
                        {
                            props.localize("qma-on") + " " + moment(productType.departureDate).format(CONFIGURATION.DATE_FORMAT) +
                            " - " + moment(productType.returnDate).format(CONFIGURATION.DATE_FORMAT) +
                            " " + props.localize("qma-with") + " " + Number(productType.noOfAdults) + adultLabel + " "
                        }
                        {`${props.localize("qma-and")}  ${Number(productType?.noOfChildren ?? 0)} ${props.localize((productType?.noOfChildren ?? 0) > 1 ? "qma-children" : "qma-child")}`}

                    </div>
                    {outboundFlights.length > 0 && inboundFlights.length > 0 ? 
                        <>
                            <div className="flights-selected-summary">
                                <div className="summary-heading">{ props.localize("qma-flight-details") }</div>
                                <FlightSection {...props} flights={outboundFlights} sectionHeading={props.localize("qma-departing-flight")} className="margin-top-1x" />
                                <FlightSection {...props} flights={inboundFlights} sectionHeading={props.localize("qma-returning-flight")} className="margin-top-2x" />
                            </div>
                        </>
                        
                        : null
                    }
                    { productTypeCode && (productTypeCode === CONSTANTS.PACKAGE || productTypeCode === CONSTANTS.HOTEL) && 
                        <div className="hotel-selected-summary">
                            <div className="summary-heading">{ props.localize("qma-hotel-details") }</div>
                            <div className="summary-grid">
                                {productType.products?.map((product, productIndex) => (
                                    product.name && 
                                        <div key={productIndex}>
                                            <div className="hotel">

                                                {
                                                    product.name.trim().length > 0
                                                        ? <ProductTypeIcon productType="hotel" className="font-orange"/>
                                                        : ""
                                                }

                                                <span className="hotel-name text-ellipsis">{product.name}</span>
                                            </div>

                                            {product.roomTypes?.map((roomType, roomTypeIndex) => {
                                                const roomName = (roomType.code === CONFIGURATION.CUSTOM_ROOM_TYPE_CODE && roomType.customName !== undefined && roomType.customName !== "" ? roomType.customName : roomType.name);
                                                return (roomName === null || roomName === undefined || roomName === "") ? null : (
                                                    <div key={roomTypeIndex} className="text-ellipsis">
                                                        {roomName}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                ))}
                            </div>
                        </div>
                    }

                </div>
            ) : null}
        </Fragment>
    );
};
export default withLocalizer(ProductType);